import { render, staticRenderFns } from "./AccountProfileEdit.vue?vue&type=template&id=3ad99d66"
import script from "./AccountProfileEdit?vue&type=script&lang=ts&external"
export * from "./AccountProfileEdit?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports